import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { key, store } from './store/store';
import Toaster from '@incuca/vue3-toaster';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';
createApp(App).use(store, key).use(router).use(Toaster).mount('#app');
